export const apiURL =  process.env.REACT_APP_API_URL ?? "" ;

export const APPkeycloakConfig = {
    "url":process.env.REACT_APP_KEYCLOAK_URL ?? "",
    "realm":process.env.REACT_APP_KEYCLOAK_REALM ?? "",
    "clientID":process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? "",
    "clientUUID":process.env.REACT_APP_KEYCLOAK_CLIENT_UUID ?? "",
    // Le Keycloak du serveur client MPS refuse l'echange PKCE : REACT_APP_KEYCLOAK_PKCE=false
    // le desactive pour cet environnement uniquement. Absente, la variable laisse le defaut
    // de keycloak-js (PKCE actif), donc dev et prod IGY ne changent pas de comportement.
    "pkce":process.env.REACT_APP_KEYCLOAK_PKCE !== "false"
};
